import React from "react";

export default function FloatingFilterPanel({ filters, onRemove }) {
  return (
    <div
      className="card flex-fill border-primary attendance-bg"
      style={{
        position: "fixed",
        bottom: 0,
        right: 20,
        maxWidth: 300,
        // background: "white",
        borderRadius: 10,
        padding: "10px 12px",
        boxShadow: "0 4px 15px rgba(0,0,0,0.15)",
        zIndex: 9999,
      }}
    >
      <div>
        <div className="fw-medium text-gray-5 mb-1">Selected Filters</div>

        <div style={{ display: "flex", flexWrap: "wrap", gap: "6px" }}>
          {filters.map((item) => (
            <div
              key={item}
              style={{
                display: "flex",
                alignItems: "center",
                padding: "4px 8px",
                background: "#e8f0ff",
                borderRadius: 20,
                fontSize: 13,
                fontWeight: 500,
              }}
            >
              {item}
              <span
                onClick={() => onRemove(item)}
                style={{
                  marginLeft: 8,
                  cursor: "pointer",
                  fontWeight: 700,
                }}
              >
                ×
              </span>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
